angular.module('webremote.dashboard').controller('widget_liveMonitoring', 
function ($scope, $log) {

    // TODO

});
